import api, { getApiErrorMessage } from "./api.service";
import { getTaskStatusWithRecovery } from "./taskStatus.service";
import { API_ENDPOINTS } from "../config.js"
  


export interface GeneExpressionRequest {
  geneName: string;
  params: Record<string, any>;
}

export interface GeneExpressionResponse {
  status: "success" | "error";
  message: string;
  tableData: any[];           // rows: [{ barcode, UMAP1, UMAP2, GENE, ... }, ...]
  genesList?: string[];
  selectedGene?: string;
  artifactId?: string;
  artifactStep?: string;
}

const waitForTask = async (taskId: string): Promise<GeneExpressionResponse> => {
  // Allow slow gene-expression computations to finish for up to 30 minutes.
  for (let attempt = 0; attempt < 1800; attempt += 1) {
    const response = await getTaskStatusWithRecovery(taskId, 1000);
    if (typeof response.status === "number" && (response.status < 200 || response.status >= 300)) {
      throw new Error(getApiErrorMessage(response, "Could not check the analysis status."));
    }
    const payload = response.data;
    if (payload.state === "SUCCESS") return payload.result as GeneExpressionResponse;
    if (payload.state === "FAILURE") {
      throw new Error(payload.result?.message || "Gene expression task failed");
    }
    await new Promise((resolve) => setTimeout(resolve, 1000));
  }
  throw new Error("Gene expression is taking longer than 30 minutes. Reopen the project to check the saved result.");
};


const fetchGeneExpression = async (
  projectName: string,
  gene: string,
  step = "umap",
): Promise<GeneExpressionResponse> => {
  const url = API_ENDPOINTS.GET_GENE_EXPRESSION_URL(projectName);
  const response = await api.post<any>(url,
    {
      geneName: gene,
      params: { step },
    },
  );
  if (response.data?.task_id) {
    return waitForTask(response.data.task_id);
  }
  return response.data as GeneExpressionResponse;
};

const analysisService = {
  fetchGeneExpression,
};

export default analysisService;
